// extracted by mini-css-extract-plugin
module.exports = {"highlight":"Highlight_highlight__1xkDj","typeIcon":"Highlight_typeIcon__3VCeg","html":"Highlight_html__QUYml"};